(function () {
	'use strict';

	angular.module('app.core')
		.service('stockRequirementFiltersService', stockRequirementFiltersService);

	stockRequirementFiltersService.$inject = ['$http', '$q', '$filter', '$experiments', 'URLS', 'tableService', 'itemDetailsPendingRequestsService',
		'numberFormatService', 'integerFormatService', 'userConfigUtilsService', 'storeService'];
	function stockRequirementFiltersService($http, $q, $filter, $experiments, URLS, tableService, itemDetailsPendingRequestsService,
			numberFormatService, integerFormatService, userConfigUtilsService, storeService) {
		var itemCode;
		var factoryNdx;
		var defaultSiteConfig;
		var dateFilter = {
			'Open POs & Rqmts': {
				filterBeginId: '',
				filterBeginDate: '',
				filterEndId: '',
				filterEndDate: '',
				dateFilterOptions: {
					showWeeks: false
				}
			},
			'Historical Metrics': {
				filterBeginId: '',
				filterBeginDate: '',
				filterEndId: '',
				filterEndDate: '',
				dateFilterOptions: {
					showWeeks: false
				}
			}
		};
		var persistedDateFilter = {
			'Open POs & Rqmts': {
				filterBeginId: '',
				filterBeginDate: '',
				filterEndId: '',
				filterEndDate: '',
				dateFilterOptions: {
					showWeeks: false
				}
			},
			'Historical Metrics': {
				filterBeginId: '',
				filterBeginDate: '',
				filterEndId: '',
				filterEndDate: '',
				dateFilterOptions: {
					showWeeks: false
				}
			}
		};
		var supplyFilters = {
			mrpTypes: {
				id: 'mrpTypes',
				values: [
					'Forecast',
					'Requirement',
					'ProductionOrder',
					'PlannedProductionOrder',
					'TransferOrder',
					'PlannedTransferOrder',
					'CustomerOrder',
					'Purchase Order',
					'Purchase Requisition',
					'Production Order',
					'Planned Production Order',
					'Non Value Supply',
					'InventoryExpiration'
				]
			},
			deliveryDateStatus: {
				id: 'deliveryDateStatus',
				values: [
					'Unconfirmed PO',
					'Confirmed PO',
					'Committed in ERP',
					'Committed in LeanDNA',
					'Shipped - Tracking in LeanDNA',
					'Shipped - ASN in ERP'
				]
			},
			confirmationStatusUsed: {
				id: 'confirmationStatusUsed',
				values: [
					'Unconfirmed PO',
					'Confirmed PO',
					'Committed in ERP',
					'Committed in LeanDNA',
					'Shipped - Tracking in LeanDNA',
					'Shipped - ASN in ERP',
					'Unconfirmed',
					'Confirmed',
					'In Transit'
				]
			},
			ignoreSupplyPastDue: {
				id: 'ignoreSupplyPastDue',
				values: ['0', '0']
			},
    	ignoreDemandPastDue: { 
				id: 'ignoreDemandPastDue',
				values: ['0', '0']
			},
			supplyDate: {
				id: 'supplyDate',
				values: ['addDate']
			}
		};
		var usingSiteDefaultConfig = true;
		var defaultSupplyFilters = _.cloneDeep(supplyFilters);
		var supplyFiltersSiteLevelDefaults = {};
		var mrpData;
		var mrpTotal;
		var itemMetricData;
		var opened;
		var mrpDataLoading;
		resetDefaultData();
		var MRP_MAX_RESULTS = 1001;

		var itemMetrics = [
			{ key: 'unrestrictedAndConsignmentStock', display: 'Available Qty', selected: true },
			{ key: 'blockedStock', display: 'Blocked Stock' },
			{ key: 'inventoryOnHand', display: 'Total On Hand' },
			{ key: 'targetQuantity', display: 'Target Quantity', selected: true },
			{ key: 'safetyStockComputed', display: 'Total safety stock' },
			{ key: 'safetyStock', display: 'Safety stock quantity' },
			{ key: 'safetyTime', display: 'Safety stock days' },
			{ key: 'minimumOrderQuantity', display: 'MOQ' },
			{ key: 'minLevel', display: 'Min Level' },
			{ key: 'maxLevel', display: 'Max Level' },
			{ key: 'erpOrderPolicy', display: 'ERP Order Policy' },
			{ key: 'orderInterval', display: 'Order Interval' },
			{ key: 'leadTime', display: 'Lead Time' },
			{ key: 'reorderPoint', display: 'Reorder Point' },
			{ key: 'reorderQuantity', display: 'Reorder Quantity' },
			{ key: 'erpExceptionMsgPoCt', display: 'ERP Exception Message PO Count' },
			{ key: 'apexPoActionPoCt', display: 'APEX PO Action PO Count' },
			{ key: 'daysUntilShortage', display: 'Days Until Shortage' },
			{ key: 'pastDuePOs', display: 'Past Due POs' },
			{ key: 'onOrderInsideLeadTime', display: 'POs Inside Lead Time' },
			{ key: 'totalPOs', display: 'Total POs' },
			{ key: 'pastDueRequirements', display: 'Past Due Requirements' },
			{ key: 'requirementsInsideLeadTime', display: 'Requirements Inside Lead Time' },
			{ key: 'totalRequirements', display: 'Total Requirements' },
			{ key: 'itemCost', display: 'Item Cost' },
			{ key: 'aggregateRiskScore', display: 'Aggregate Risk Score' }
		];

		var ahuMetric = [
			{ key: 'averageHistoricalUsage', display: 'Average Historical Usage' }
		];

		var restrictedItemMetrics = [
			{ key: 'poToActionPotentialSavings', display: 'PO to Action - Potential Savings' },
			{ key: 'poToActionRemainingPOs', display: 'PO to Action - Remaining POs' },
			{ key: 'poToActionRemainingRequirements', display: 'PO to Action - Remaining Requirements' }
		];

		getConfig();

		return {
			getItemCode: getItemCode,
			getFactoryNdx: getFactoryNdx,
			clearData: clearData,
			resetDateFilterData: resetDateFilterData,
			getMrpData: getMrpData,
			getFilteredMrpList: getFilteredMrpList,
			updateConfig: updateConfig,
			deleteConfig: deleteConfig,
			updateRowDataAfterEdited: updateRowDataAfterEdited,
			getSupplyFilters: getSupplyFilters,
			getItemMetricData: getItemMetricData,
			setItemMetricData: setItemMetricData,
			getMrpTotal: getMrpTotal,
			setMrpTotal: setMrpTotal,
			getItemMetrics: getItemMetrics,
			getDateFilter: getDateFilter,
			getPersistedDateFilter: getPersistedDateFilter,
			loadMrpList: loadMrpList,
			getOpened: getOpened,
			setOpened: setOpened,
			getMrpDataLoading: getMrpDataLoading,
			setMrpDataLoading: setMrpDataLoading,
			getMrpMaxResults: getMrpMaxResults,
			saveSiteLevelDefaultConfig: saveSiteLevelDefaultConfig,
			getSiteLevelDefaultConfig: getSiteLevelDefaultConfig,
			resetToSiteDefault: resetToSiteDefault,
			getSupplyAndDemandDefaultFilters: getSupplyAndDemandDefaultFilters,
			getUsingSiteDefaultConfig: getUsingSiteDefaultConfig
		};

		function getMrpMaxResults() {
			return MRP_MAX_RESULTS;
		}

		function getItemCode() {
			return itemCode;
		}

		function getFactoryNdx() {
			return factoryNdx;
		}

		function getMrpDataLoading(viewMode) {
			return mrpDataLoading[viewMode];
		}

		function getUsingSiteDefaultConfig() {
			return usingSiteDefaultConfig;
		}

		function setMrpDataLoading(viewMode, isLoading) {
			mrpDataLoading[viewMode] = isLoading;
		}

		function clearData(incomingItemCode, incomingFactoryNdx) {
			itemCode = incomingItemCode;
			factoryNdx = incomingFactoryNdx;
			resetDefaultData();
		}

		function copyDateDataInner(viewMode, from, to) {
			to[viewMode].filterBeginId = from[viewMode].filterBeginId;
			to[viewMode].filterBeginDate = from[viewMode].filterBeginDate;
			to[viewMode].filterEndId = from[viewMode].filterEndId;
			to[viewMode].filterEndDate = from[viewMode].filterEndDate;
		}

		function copyDateData(from, to) {
			copyDateDataInner('Open POs & Rqmts', from, to);
			copyDateDataInner('Historical Metrics', from, to);
		}

		function resetDateFilterData() {
			copyDateData(persistedDateFilter, dateFilter);
		}

		function resetDefaultData() {
			itemMetricData = { 'Open POs & Rqmts': [], 'Historical Metrics': [] };
			opened = { 'Open POs & Rqmts':false, 'Historical Metrics': false};
			mrpDataLoading = { 'Open POs & Rqmts':false, 'Historical Metrics': false};
			mrpData = { 'Open POs & Rqmts': [], 'Historical Metrics': [] };
			mrpTotal = { 'Open POs & Rqmts': 0, 'Historical Metrics': 0 };
		}

		function resetToSiteDefault() {
			if (defaultSiteConfig && defaultSiteConfig.filters) {
				for (var i = 0; i < defaultSiteConfig.filters.length; i++) {
					var filter = defaultSiteConfig.filters[i];
					if (!_.includes(['itemMetrics', 'historicDateRange', 'openPoDateRange', 'dateUpdated'], filter.id)) {
						updateSupplyFilters(filter);
					}
				}
			}
		}

		function getSupplyAndDemandDefaultFilters() {
			return _.isEmpty(supplyFiltersSiteLevelDefaults) ? defaultSupplyFilters: supplyFiltersSiteLevelDefaults;
		}

		function getConfig(factoryNdx) {
			return tableService.getConfig('ItemDrilldown', true, null, factoryNdx)
				.then(function (config) {
					if (config && config.filters) {
						for (var i = 0; i < config.filters.length; i++) {
							var filter = config.filters[i];
							if (filter.id === 'itemMetrics') {
								updateItemMetricsFromStoredValues(filter.values);
							} else if (filter.id === 'historicDateRange') {
								updateHistoricDateRangeFromStoredValues(filter.values);
							} else if (filter.id === 'openPoDateRange') {
								updateOpenPoDateRangeFromStoredValues(filter.values);
							} else if (filter.id !== 'dateUpdated') {
								updateSupplyFilters(filter);
							}
						}
						copyDateData(dateFilter, persistedDateFilter);
						usingSiteDefaultConfig = !!config.defaultConfig;
					}
				});
		}

		function setDefaultSiteLevelConfigs(config) {
			defaultSiteConfig = null;
			supplyFiltersSiteLevelDefaults = {};
			if (!config) { 
				config= {};
			}
			if (!config.filters || !config.filters.length) {
				config['filters'] = Object.values(defaultSupplyFilters);
			}
			if (config && config.filters) {
				defaultSiteConfig = config;
				for (var i = 0; i < config.filters.length; i++) {
					var filter = config.filters[i];
					if (!_.includes(['itemMetrics', 'historicDateRange', 'openPoDateRange', 'dateUpdated'], filter.id)) {
						updateSupplyFiltersSiteLevelDefaults(filter);
					}
				}
			}
		}
		function getSiteLevelDefaultConfig(factoryNdx) {
			return tableService.getSiteLevelDefaultConfig(factoryNdx, 'ItemDrilldown', true)
				.then(function (config) {
					var hasSiteDefaultFilters = config && config.filters && config.filters.length;
					setDefaultSiteLevelConfigs(config);
					if (hasSiteDefaultFilters) {
						var possibleMissingSupplyFilters = Object.keys(defaultSupplyFilters);
						var currentSupplyFilterIds = Object.keys(supplyFiltersSiteLevelDefaults);
						
						possibleMissingSupplyFilters = _.filter(possibleMissingSupplyFilters, function (fId) {
							return !_.includes(currentSupplyFilterIds, fId);
						});
						
						if (possibleMissingSupplyFilters.length) {
							for (var i = 0; i < possibleMissingSupplyFilters.length; i++) {
								updateSupplyFiltersSiteLevelDefaults(defaultSupplyFilters[possibleMissingSupplyFilters[i]]);
							}
							saveSiteLevelDefaultConfig();
						}
					}
					if (usingSiteDefaultConfig) {
						resetToSiteDefault();
					}
				});
		}

		function updateItemMetricsFromStoredValues(values) {
			var allMetrics = getItemMetrics(true);
			_.forEach(allMetrics, function (metric) {
				metric.selected = values.indexOf(metric.key) !== -1;
			});
		}

		function updateHistoricDateRangeFromStoredValues(values) {
			dateFilter['Historical Metrics'].filterBeginId = values[0];
			if (values[0] === 'customDateOption') {
				dateFilter['Historical Metrics'].filterBeginDate = new Date(Number(values[1]));
			}
		}

		function updateOpenPoDateRangeFromStoredValues(values) {
			dateFilter['Open POs & Rqmts'].filterEndId = values[0];
			if (values[0] === 'customDateOption') {
				dateFilter['Open POs & Rqmts'].filterEndDate = new Date(Number(values[1]));
			}
		}

		function updateSupplyFilters(filter) {
			supplyFilters[filter.id] = filter;
		}

		function updateSupplyFiltersSiteLevelDefaults(filter) {
			supplyFiltersSiteLevelDefaults[filter.id] = filter;
		}

		function updateConfig(filterName) {
			var config = {
				columns: [],
				filters: [
					{
						id: 'dateUpdated',
						values: [new Date()]
					}
				],
				recordsPerPage: 0,
				search: '',
				sorters: []
			};
			config.filters.push({
				id: 'itemMetrics',
				values: getSelectedItemMetricKeys()
			});
			config.filters.push({
				id: 'historicDateRange',
				values: [dateFilter['Historical Metrics'].filterBeginId, dateFilter['Historical Metrics'].filterBeginDate]
			});
			config.filters.push({
				id: 'openPoDateRange',
				values: [dateFilter['Open POs & Rqmts'].filterEndId, dateFilter['Open POs & Rqmts'].filterEndDate]
			});
			config.filters = config.filters.concat(Object.values(supplyFilters));
			copyDateData(dateFilter, persistedDateFilter);
			tableService.updateConfig('ItemDrilldown', config, true);
			usingSiteDefaultConfig = false;
		}

		function deleteConfig() {
			tableService.deleteConfig('ItemDrilldown', true);
			usingSiteDefaultConfig = true;
		}

		function saveSiteLevelDefaultConfig() {
			var config = {
				columns: [],
				filters: [
					{
						id: 'dateUpdated',
						values: [new Date()]
					}
				],
				recordsPerPage: 0,
				search: '',
				sorters: []
			};
			config.filters.push({
				id: 'itemMetrics',
				values: getSelectedItemMetricKeys()
			});
			config.filters.push({
				id: 'historicDateRange',
				values: [dateFilter['Historical Metrics'].filterBeginId, dateFilter['Historical Metrics'].filterBeginDate]
			});
			config.filters.push({
				id: 'openPoDateRange',
				values: [dateFilter['Open POs & Rqmts'].filterEndId, dateFilter['Open POs & Rqmts'].filterEndDate]
			});
			config.filters = config.filters.concat(Object.values(supplyFilters));
			tableService.updateSiteLevelDefaultConfig(getFactoryNdx(), 'ItemDrilldown', config);
			setDefaultSiteLevelConfigs(config);
			usingSiteDefaultConfig = true;
		}

		function getSelectedItemMetricKeys() {
			var selectedMetrics = _.filter(getItemMetrics(true), function (metric) {
				return metric.selected;
			});
			var selectedKeys = _.map(selectedMetrics, function (metric) {
				return metric.key;
			});
			return selectedKeys;
		}


		function loadMrpList(itemCode, factoryNdx, target, availableQtyBalance, leadTimeInDaysFloat, viewMode) {
			setMrpDataLoading(viewMode, true);
			var url = URLS.prefix + factoryNdx + '/ItemDrilldownMrpList?limit=' + MRP_MAX_RESULTS + '&itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(getMrpListComplete)
				.catch(getMrpListFailed);

			function getMrpListComplete(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				if (itemCode !== getItemCode() || factoryNdx !== getFactoryNdx()) {
					return;
				}
				var data = response.data ? response.data.data : [];
				formatMrpListForSupplyFilter(data);
				setMrpData(viewMode, data);
				setMrpTotal(viewMode, response.data ? response.data.total : 0);
				setMrpDataLoading(viewMode, false);
				return data;
			}

			function getMrpListFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				setMrpDataLoading(viewMode, false);
				return undefined;
			}
		}

		function getMrpData(viewMode) {
			return mrpData[viewMode];
		}

		function setMrpData(viewMode, data) {
			mrpData[viewMode] = data;
		}

		function getItemMetricData(viewMode) {
			return itemMetricData[viewMode];
		}

		function setItemMetricData(viewMode, data) {
			itemMetricData[viewMode] = data;
		}

		function getItemMetrics(includeRestrictedMetrics) {
			var local = [].concat(itemMetrics);
			if (globalConfig.user.authFacts[factoryNdx].settings.RequirementSourceForCalculations !== 'Past'
				&& !_.find(local, {key: 'averageHistoricalUsage'})) {
				local = local.concat(ahuMetric);
			}
			if (includeRestrictedMetrics) {
				local = local.concat(restrictedItemMetrics);
			}
			local = local.sort(function (a, b) { 
				var aName = a.display.toLowerCase();
				var bName = b.display.toLowerCase();
				if (aName < bName) {
					return -1;
				}
				if (aName > bName) {
					return 1;
				}
				return 0;
			});
			return local;
		}

		function getDateFilter(viewMode) {
			return dateFilter[viewMode];
		}

		function getSupplyFilters(reset) {
			return reset ? _.cloneDeep(supplyFilters): supplyFilters;
		}

		function getPersistedDateFilter() {
			return persistedDateFilter;
		}

		function getMrpTotal(viewMode) {
			return mrpTotal[viewMode];
		}

		function setMrpTotal(viewMode, total) {
			mrpTotal[viewMode] = total;
		}

		function getOpened(viewMode) {
			return opened[viewMode];
		}

		function setOpened(viewMode, val) {
			opened[viewMode] = val;
		}

		function formatMrpListForSupplyFilter(data) {
			angular.forEach(data, function(row) {
				row.MRPType = getValidMrpType(row.MRPType);
			});
		}

		function checkAndAddSplitRows(data) {
			var newData = [];
			_.forEach(data, function(row) {
				if (row.ReceiptRequirement < 0) {
					newData.push(row);
				} else if (!row.poRecommendedActions || !row.poRecommendedActions.length) {
					newData.push(row);
				} else {
					var details = JSON.parse(row.poRecommendedActions);
					if (details.length === 1 ) {
						if (details[0].action !== 'cancel') {
							row.analysisRescheduleDate = new Date(details[0].analysisRescheduleDate).getTime();
							row.ReceiptRequirement = details[0].quantity;
							row.poRecommendedActions = '';
							newData.push(row);
						}
					} else {
						_.forEach(details, function(detail) {
							if (detail.action !== 'cancel') {
								var newRow = _.cloneDeep(row);
								newRow.analysisRescheduleDate = new Date(detail.analysisRescheduleDate).getTime();
								newRow.ReceiptRequirement = detail.quantity;
								newRow.poRecommendedActions = '';
								newData.push(newRow);
							}
						});
					}
				}
			});
			return newData;
		}

		function getFilteredMrpList(data, availableQtyBalance, leadTimeInDaysFloat) {
			var numDecimals = decimalPlaces(availableQtyBalance);
			var endDateForLeadTime = moment().tz('UTC').add(leadTimeInDaysFloat, 'days');
			var hasIgnoreSupplyPastDue = supplyFilters.ignoreSupplyPastDue.values[0] === '1';
			var supplyPastDueDate = moment().subtract(supplyFilters.ignoreSupplyPastDue.values[1] || 0, 'days');
			var hasIgnoreDemandPastDue = supplyFilters.ignoreDemandPastDue.values[0] === '1';
			var demandPastDueDate = moment().subtract(supplyFilters.ignoreDemandPastDue.values[1] || 0, 'days');
			var selectedSupplyDate = supplyFilters.supplyDate.values[0] || 'addDate';

			if (selectedSupplyDate === 'analysisRescheduleDate') {
				data = checkAndAddSplitRows(data);
			}

			data.sort(function (a, b) {
				return (a[selectedSupplyDate] || a.addDate) - (b[selectedSupplyDate] || b.addDate);
			});
			var result = _.map(data, function (row) {
				if (!applySupplyFilters(row, selectedSupplyDate, hasIgnoreSupplyPastDue, supplyPastDueDate, hasIgnoreDemandPastDue, demandPastDueDate) ||
						(row.isBlanketOrder === 1 && supplyFilters.mrpTypes.values.includes('Exclude blanket orders')) ||
						(row.nonQuantity === 1 && row.nonValue === 1)) {
					return null;
				}
				var sDate = row[selectedSupplyDate] || row.addDate;
				var originalDt = new Date(sDate);
				var rescheduleDt = null;

				if (typeof row.reScheduleDate === 'undefined' ||
					row.reScheduleDate === '' ||
					sDate === row.reScheduleDate) {
					row.dateChange = false;
				} else {
					row.dateChange = true;
					rescheduleDt = new Date(row.reScheduleDate);
					row.reScheduleDate = $filter('date')(rescheduleDt, 'shortDate', 'UTC');
				}

				row[selectedSupplyDate] = $filter('date')(originalDt, 'shortDate', 'UTC');
				row.originalDate = originalDt;
				row.insideLeadTime = moment(originalDt).tz('UTC').isBefore(endDateForLeadTime);

				numDecimals = Math.max(numDecimals, decimalPlaces(row.ReceiptRequirement));
				var rrMult = row.ReceiptRequirement < 0 ? '-' : '';
				availableQtyBalance += row.ReceiptRequirement;
				var aqMult = availableQtyBalance < 0 ? '-' : '';

				if (availableQtyBalance % 1 !== 0 && (availableQtyBalance < 100 && availableQtyBalance > -100)) {
					row.availableQtyBalance = aqMult + numberFormatService.getWithParameters(availableQtyBalance, numDecimals);
				} else {
					row.availableQtyBalance = aqMult + integerFormatService.getWithParameters(availableQtyBalance, 0);
				}
				row.availableQtyBalanceUnformatted = availableQtyBalance;

				row.originalReceiptRequirement = row.ReceiptRequirement;
				if (row.ReceiptRequirement % 1 !== 0 && (row.ReceiptRequirement < 100 && row.ReceiptRequirement > -100)) {
					row.ReceiptRequirement = rrMult + numberFormatService.getWithParameters(row.ReceiptRequirement, numDecimals);
				} else {
					row.ReceiptRequirement = rrMult + integerFormatService.getWithParameters(row.ReceiptRequirement, 0);
				}
				return row;
			});
			return _.filter(result, function (row) { return row;} );
		}

		function applySupplyFilters(row, selectedSupplyDate, hasIgnoreSupplyPastDue, supplyPastDueDate, hasIgnoreDemandPastDue, demandPastDueDate) {
			var sDate = row[selectedSupplyDate] || row.addDate;
			return isMrpTypeSelected(row) &&
			!((getMainMrpType(row.MRPType) === 'SUPPLY' && hasIgnoreSupplyPastDue && moment(sDate).isBefore(supplyPastDueDate)) ||
			(getMainMrpType(row.MRPType) === 'DEMAND' && hasIgnoreDemandPastDue && moment(sDate).isBefore(demandPastDueDate)));
		}

		function isMrpTypeSelected(row) {
			return supplyFilters.mrpTypes.values.indexOf(row.MRPType) !== -1 &&
				(row.MRPType !== 'Purchase Order' || (
					userConfigUtilsService.getUsePoConfirmationsForSite(row.factoryNdx) === '1' ?
						supplyFilters.confirmationStatusUsed.values.indexOf(row.confirmationStatusUsed) !== -1 :
						supplyFilters.deliveryDateStatus.values.indexOf(row.confirmationStatusUsed) !== -1)
				);
		}

		function getMainMrpType(mrpType) {
			switch (mrpType) {
			case 'On Hand':
			case 'Consignment Stock':
				return 'ON_HAND';
			case 'Purchase Order':
			case 'Purchase Requisition':
			case 'Planned Production Order':
			case 'Production Order':
			case 'Non Value Supply':
				return 'SUPPLY';
				// the remaining are demand type
			default:
				return 'DEMAND';
			}
		}

		function getValidMrpType(mrpType) {
			switch(mrpType) {
			case 'On Hand':
			case 'Consignment Stock':
			case 'Forecast': 
			case 'Requirement': 
			case 'ProductionOrder': 
			case 'PlannedProductionOrder': 
			case 'TransferOrder': 
			case 'PlannedTransferOrder': 
			case 'CustomerOrder': 
			case 'Purchase Order': 
			case 'Purchase Requisition': 
			case 'Production Order': 
			case 'Planned Production Order': 
			case 'Non Value Supply': 
			case 'InventoryExpiration':
				return mrpType;
			default: 
				return 'Requirement';
			}
		}

		function updateRowDataAfterEdited(viewMode, updateData) {
			var dataList = getMrpData(viewMode);
			angular.forEach(dataList, function(row) {
				if (updateData.data.itemNdx === row.itemNdx &&
					updateData.data.poNumber === (row.poNumber || row.orderNumber || row.supplyOrderNumber) &&
					updateData.data.poLine === (row.orderLine || row.supplyOrderLine) &&
					updateData.data.scheduleLine === (row.scheduleLine || row.supplyScheduleLine)
				) {
					row.firstPoEcd = updateData.rowDataUpdates.firstPoEcd;
					row.firstPoEcdDate = updateData.rowDataUpdates.firstPoEcdDate;
				}
			});
		}

		function setTitleForMrpRow(row) {
			if (row.MRPType === 'Purchase Order') {
				row.title = 'Supplier: ' + row.supplierName;
			} else {
				row.title = '';
			}
		}
	}
})();
